import {AfterViewInit, Component, Inject, ViewChild} from '@angular/core';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import type { Colaborador as ColaboradorModel } from '../models/Colaborador';
import {MatTableDataSource, MatTableDataSourcePaginator} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";

@Component({
  selector: 'ral-listado-colaboradores',
  templateUrl: './listado-colaboradores.component.html',
  styleUrls: ['./listado-colaboradores.component.scss']
})
export class ListadoColaboradoresComponent extends VentanaFlotante implements AfterViewInit{
  colaboradores: ColaboradorModel[] = [];
  protected columnsToDisplay = ['cp', 'poblacion', 'provincia', 'taller', 'direccion', 'telefono', 'horariolv', 'horariosb', 'horariomv'];
  dataSource = new MatTableDataSource(this.colaboradores);

  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: { colaboradores: ColaboradorModel[] },
  )
  {
    super(dialogRef, data);
    this.colaboradores = data.colaboradores;
  }

  @ViewChild(MatPaginator) paginator: MatTableDataSourcePaginator | null=null;

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  ngOnInit() {
    this.dataSource.data = this.colaboradores;
  }
  cargarColaborador(colaborador:ColaboradorModel): void {
    this.dialogRef.close(colaborador);
  }

  onPageChange(event: any)
  {
    if(this.paginator)
      this.paginator.pageIndex = event.pageIndex;
  }
}
